import React from "react";
import { useBetslipStore } from "@/features/betslip/stores/betslipStore";
import { SlipAlert } from "@/features/betslip/components/parts/SlipAlert";

import * as styles from "@/features/betslip/components/GlobalAlerts.module.scss";

export const GlobalAlerts = () => {
  const transportError = useBetslipStore((s) => s.transportError);
  const dismissTransportError = useBetslipStore((s) => s.dismissTransportError);

  if (!transportError) return null;

  return (
    <div data-testid="global-alerts" className={styles.container}>
      <SlipAlert
        alert={transportError}
        onCta={(cta) => {
          if (cta.action === "dismissTransportError") {
            dismissTransportError();
          }
        }}
      />
    </div>
  );
};
